module.exports = __webpack_public_path__ + "static/media/econobit-text-dark-testnet.450648f7.svg";